import Service from '@/service/index.js';
import { mapGetters } from 'vuex';
import Service1 from './service';
import LocationSelect from '@/components/location-select/index.vue';
import ProjectService from '../../../project.service.js';

export default {
  components: {
    LocationSelect
  },
  props: ['transfereeInfo'],
  data() {
    return {
      managementSubjectCodeArr: [],
      transferTypeArr: [],
      payTypeArr: [],
      circulationTypeCodeArr: [],
      bidTypeArr: [],
      projectPurposeArr: [],
      contractorPriorityCodeArr: [],
      tradeTypeArr: [],
      type1: ['1-1', '1-2', '3-1', '4-1', '4-2', '4-3', '4-4'],
      type2: ['2-1', '2-2', '2-3'],
      type3: ['6-1', '7-1', '7-2'],
      type4: ['2-1', '2-3'],
      landtypeArr: [],
      projectInfo: {},
      areaName: '',
      areaName1: '',
      areaName2: '',
      areaName3: ''
    };
  },
  created() {
    this.id = this.$route.query.id;
    const obj = {
      MANAGEMENT_SUBJECT: 'managementSubjectCodeArr',
      TRANSFER_TYPE: 'transferTypeArr',
      PAY_TYPE: 'payTypeArr',
      CIRCULATION_TYPE: 'circulationTypeCodeArr',
      BIDDING_METHOD: 'bidTypeArr',
      PROJECT_PURPOSE: 'projectPurposeArr',
      CONTRACTOR_PRIORITY: 'contractorPriorityCodeArr',
      TRADE_TYPE: 'tradeTypeArr',
      LAND_CATEGORY: 'landtypeArr'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
    ProjectService.getBatchProject(this.id).then(res => {
      this.projectInfo = res.data;
      Service1.getLocationList(23, 2).then(res => {
        res.data.forEach(item => {
          if(item.areaCode === this.projectInfo.city) {
            this.areaName = item.areaName;
          }
        });
      });
      Service1.getLocationList(this.projectInfo.city, 3).then(res => {
        res.data.forEach(item => {
          if(item.areaCode === this.projectInfo.county) {
            this.areaName1 = item.areaName;
          }
        });
        Service1.getLocationList(this.projectInfo.county, 4).then(res => {
          res.data.forEach(item2 => {
            if(item2.areaCode === this.projectInfo.township) {
              this.areaName2 = item2.areaName;
            }
          });
          Service1.getLocationList(this.projectInfo.township, 5).then(res => {
            res.data.forEach(item3 => {
              if(item3.areaCode === this.projectInfo.village) {
                this.areaName3 = item3.areaName;
              }
            });
          });
        });
      });
    });
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    unBidSelText () {
      const str = this.projectInfo && this.projectInfo.addressDetail;
      if (str) {
        return str.split(' ').slice(1).join('');
      }
      return '';
    },
    projectCode() {
      if(this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
        return `${this.projectInfo.projectType}-${this.projectInfo.projectSubType}`;
      }
    }
  },
  methods: {
    getLocationList() {
      Service1.getLocationList(this.projectInfo.village, 5).then(res => {
        console.log(res);
      });
    }
  }
};
